// zettel_list_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["zettel"]

  connect() {
    document.addEventListener("turbo:load", this.updateActiveZettel.bind(this))
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.updateActiveZettel.bind(this))
  }

  updateActiveZettel() {
    // Get the current zettel slug from the URL
    var url = new URL(window.location.href)
    var zettelSlug = url.pathname.split("/zettel/")[1]?.split("?")[0] || null

    // Remove active class from all zettel items
    this.zettelTargets.forEach((zettel) => {
      zettel.classList.remove("active")
    })

    // Add active class to the matching zettel item
    if (zettelSlug) {
      var activeZettel = this.zettelTargets.find(
        (zettel) => zettel.dataset.slug === zettelSlug
      )
      if (activeZettel) {
        activeZettel.classList.add("active")
      }
    }
  }
}
